import React from "react";
import Footer from "../Footer/Footer";
const Blog = () => {
  return (
    <>
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h1 className="welcome-dashboard">Blog section coming soon</h1>
      </div>
      <Footer></Footer>
    </>
  );
};

export default Blog;
